import { Skeleton } from '@skin-seoul/design-system';

const CartProductCardSkeleton = ({ showDivider = false, isFirst = false }: { showDivider?: boolean; isFirst?: boolean }) => (
  <div aria-hidden="true" className={`w-full pb-4 ${isFirst ? 'pt-5' : 'pt-4'} ${showDivider ? 'border-b border-neutral-50' : ''}`}>
    <div className="flex w-full min-w-0 gap-4">
      <Skeleton className="h-28 w-[90px] rounded-lg motion-reduce:animate-none" />
      <div className="flex min-w-0 flex-1 flex-col justify-between">
        <div className="flex flex-col gap-2">
          <div className="flex h-6 items-center justify-between gap-2">
            <Skeleton className="h-4 w-[75%] motion-reduce:animate-none" />
            <Skeleton className="size-6 rounded-full motion-reduce:animate-none" />
          </div>
          <Skeleton className="h-3 w-1/2 motion-reduce:animate-none" />
        </div>
        <div className="flex items-center justify-between gap-2">
          <Skeleton className="h-8 w-24 rounded-lg motion-reduce:animate-none" />
          <Skeleton className="h-4 w-14 motion-reduce:animate-none" />
        </div>
      </div>
    </div>
  </div>
);
export default CartProductCardSkeleton;
